module.exports = __webpack_public_path__ + "img/icon-pickup-cost-yellow.11e3ff56.svg";